import React, { useEffect, useState } from "react";
import FormikWrapper from "../../../../FormikWrapper";
import { customerSignUpSchema } from "../../../../../formValidation";
import Loader from "../../../../Loader";
// import AppleButton from "../ThirdParty/AppleAuth";
// import FacebookButton from "../ThirdParty/FacebookAuth";
// import GoogleButton from "../ThirdParty/GoogleAuth";
import RegistrationForm from "./RegistrationForm";
import {
  customerSignUp,
  sendOtp,
  setupRecaptcha,
} from "../../../../../services/customer/auth";
import { getStates } from "../../../../../services/customer/dropdown";
import { getAuth } from "firebase/auth";
import { app } from "../../../../../firebase";
import useFirebaseToken from "../../../../../hooks/useFirebaseToken";

interface CustomerSignUpProps {
  show: boolean;
  closeModal: CallableFunction;
  currentTabName: string;
  setOtpModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setContactNumber?: React.Dispatch<React.SetStateAction<string>>;
}

const CustomerSignUp: React.FC<CustomerSignUpProps> = ({
  show,
  closeModal,
  currentTabName,
  setOtpModal,
  setContactNumber,
}) => {
  const defaultInitialValues: any = {
    email: "",
    password: "",
    confirmPassword: "",
    full_name: "",
    address: "",
    location: "",
    state_id: "",
    city_id: "",
    postal_code: "",
    contact_number: "",
    lat: "",
    long: "",
    role: 4,
    seller_type: 4,
  };

  const [initialValues, setInitialValues] = useState(defaultInitialValues);
  const notificationToken = useFirebaseToken();

  const [loading, setLoading] = useState<boolean>(false);
  const [addressDetails, setAddressDetails] =
    useState<google.maps.places.PlaceResult | null>(null);

  const handleLocationDetails = (
    addressDetails: google.maps.places.PlaceResult
  ) => {
    setAddressDetails(addressDetails);
  };

  const handleLoader = (value: boolean) => {
    setLoading(value);
  };

  const auth = getAuth(app);

  const handleApiResponse = (data: any) => {
    setInitialValues(defaultInitialValues);
    closeModal();
    setOtpModal && setOtpModal(true);
    setContactNumber && setContactNumber(`+91${data?.contact_number}`);
    setupRecaptcha(auth);
    const appVerifier = (window as Window | any).recaptchaVerifier;
    sendOtp(
      appVerifier,
      auth,
      `+91${data?.contact_number}`,
      (confirmation: any) => {
        if (confirmation) {
          (window as Window | any).confirmationResult = confirmation;
        }
      }
    );
  };

  const handleOnSubmit = (value: any) => {
    handleLoader(true);
    const apiData = {
      full_name: value?.full_name,
      role: Number(value?.role),
      seller_type:
        Number(value?.role) === 5 ? Number(value?.seller_type) : null,
      email: value?.email?.toLowerCase(),
      password: value?.password,
      location: value?.address,
      lat: addressDetails?.geometry?.location?.lat().toString(),
      long: addressDetails?.geometry?.location?.lng().toString(),
      postal_code: value?.postal_code,
      state_id: value?.state_id?.value,
      city_id: value?.city_id?.value,
      contact_number: value?.contact_number,
      device_type: "web",
      device_token: notificationToken?.token ?? "",
    };

    customerSignUp(handleApiResponse, handleLoader, apiData);
  };

  const [statesList, setStatesList] = useState([]);
  const handleStates = (state: any) => {
    const setStateList = state?.map((item: any) => ({
      value: item._id,
      label: item.name,
    }));
    setStatesList(setStateList);
  };

  useEffect(() => {
    if (show && currentTabName === "registration") {
      getStates(handleStates);
    }
  }, [show, currentTabName]);

  return (
    <div className="w-full">
      <FormikWrapper
        initialValues={initialValues}
        validationSchema={customerSignUpSchema}
        onSubmit={handleOnSubmit}
        buttonProps={{
          children: loading ? (
            <Loader size="small" />
          ) : (
            <span className="py-1 font-bold text-2xl">Sign Up</span>
          ),
          className: "w-full mt-8 mb-5",
          isDisabled: loading,
        }}
      >
        <RegistrationForm
          addressDetails={addressDetails}
          handleLocationDetails={handleLocationDetails}
          statesList={statesList}
        />
      </FormikWrapper>
      {/* <div className="space-y-6 mt-5 px-4 py-6 border-t-2 border-t-black">
        <h3 className="font-normal text-lg text-center">Or connect with:</h3>
        <AppleButton />
        <FacebookButton />
        <GoogleButton />
      </div> */}
    </div>
  );
};

export default CustomerSignUp;
